import { Injectable } from '@angular/core';
import { BdLRUCache } from '@bindoc-projects/util-lib/logic';
import { BdGraphApiUser } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class BdUsersCacheService {
  private _cache = new BdLRUCache(50);

  public get(userId: string): BdGraphApiUser | null {
    return this._cache.get(userId) as BdGraphApiUser | null;
  }

  public set(user: BdGraphApiUser): void {
    this._cache.set(user.id, user);
  }
}
